import { render, staticRenderFns } from "./partnerBranchSummary.vue?vue&type=template&id=7097a89b&scoped=true"
import script from "./partnerBranchSummary.vue?vue&type=script&lang=js"
export * from "./partnerBranchSummary.vue?vue&type=script&lang=js"
import style0 from "./partnerBranchSummary.vue?vue&type=style&index=0&id=7097a89b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097a89b",
  null
  
)

export default component.exports